const baseUrl = process.env.REACT_APP_S3_BUCKET_BASE_URL;

export const prmedia_thermatru_press_release = 
{
    ref : 'prmedia_thermatru_press_release',
    title : 'Explore More Tools',
    area :'PR & Media Therma-Tru',

    info_default_view : false,
    info_navigation_view : true,
    navigationLevel : 2,
    navigation_box : '',
    parent : 'prmedia_thermatru',
    footerdiscription : true,

    ContentComponents: [

        {
            navigation_ref: 'door_system',
            type: 'navigation_box',
            title: 'Door System Brochure',
            footerdiscription : true,
            discription : 'Press Releases',

            buttonList: [
                {
                    title: `Virtual Experience, International Builders' Show and Keys 2 Success`,
                    type : 'navigationbuttonlist',
                    contentKey : 'prmedia_thermatru_press_release_ve'
                },
                {
                    title: '2023 Fiberglass New Products',
                    type : 'navigationbuttonlist',
                    contentKey : 'prmedia_thermatru_press_release_shaker'

                },
                {
                    title: '2023 Veris Collection',
                    type : 'navigationbuttonlist',
                    contentKey : 'prmedia_thermatru_press_release_retracable'

                },
                // {
                //     title: 'NHVS',
                //     type : 'navigationbuttonlist',
                //     contentKey : 'prmedia_thermatru_press_release_nhvs'

                // },
                // {
                //     title: 'Key 2 Success',
                //     type : 'navigationbuttonlist',
                //     contentKey : 'prmedia_thermatru_press_release_ke2scs'

                // },
                // {
                //     title: 'Impressions Outswing',
                //     type : 'navigationbuttonlist',
                //     contentKey : 'prmedia_thermatru_press_release_impressions'

                // },
                // {
                //     title: 'CCM 3/4 LITE',
                //     type : 'navigationbuttonlist',
                //     contentKey : 'prmedia_thermatru_press_release_ccm34'

                // },
                // {
                //     title: 'Therma-Tru THRIVE',
                //     type : 'navigationbuttonlist',
                //     contentKey : 'prmedia_thermatru_press_release_thrive'

                // },
                // {
                //     title: `8'0"" Doors with Elevated Bottom Rail`,
                //     type : 'navigationbuttonlist',
                //     contentKey : 'prmedia_thermatru_press_release_bottom'

                // },
            ]
        },

    ],
    navigationComponents: [
        // { key : 'door_system' , name: 'Door System Brochure'},

    ],


}

export const prmedia_thermatru_press_release_bottom = {
    title: `8'0"" Doors with Elevated Bottom Rail`,
    area :'PR & Media Therma-Tru',
    ref : 'prmedia_thermatru_press_release_bottom',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/TT PR & Media Press Release Placeholder.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_press_release',
}


export const prmedia_thermatru_press_release_thrive = {
    area :'PR & Media Therma-Tru',
    title: 'Therma-Tru THRIVE',
    ref : 'prmedia_thermatru_press_release_thrive',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/TT PR & Media Press Release Placeholder.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_press_release',
}


export const prmedia_thermatru_press_release_ccm34 = {
    area :'PR & Media Therma-Tru',
    title: 'CCM 3/4 LITE',

    ref : 'prmedia_thermatru_press_release_ccm34',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/TT PR & Media Press Release Placeholder.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_press_release',
}




export const prmedia_thermatru_press_release_impressions = {
    area :'PR & Media Therma-Tru',
    title: 'Impressions Outswing',

    ref : 'prmedia_thermatru_press_release_impressions',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/TT PR & Media Press Release Placeholder.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_press_release',
}

export const prmedia_thermatru_press_release_ke2scs = {
    area :'PR & Media Therma-Tru',
    title: 'Key 2 Success',

    ref : 'prmedia_thermatru_press_release_ke2scs',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/TT PR & Media Press Release Placeholder.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_press_release',
}

export const prmedia_thermatru_press_release_nhvs = {
    area :'PR & Media Therma-Tru',
    title: 'NHVS',

    ref : 'prmedia_thermatru_press_release_nhvs',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/TT PR & Media Press Release Placeholder.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_press_release',
}


export const prmedia_thermatru_press_release_retracable = {
    area :'PR & Media Therma-Tru',
    title : '2023 Veris Collection',
    ref : 'prmedia_thermatru_press_release_retracable',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/23_Therma-Tru_PressRelease_Veris.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_press_release',
}

export const prmedia_thermatru_press_release_ve = {
    area :'PR & Media Therma-Tru',
    title: `Virtual Experience, International Builders' Show and Keys 2 Success`,
    ref : 'prmedia_thermatru_press_release_ve', 
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/23_Therma-Tru_PressRelease_IBS VE K2S.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_press_release',
}

export const prmedia_thermatru_press_release_shaker = {
    area :'PR & Media Therma-Tru',
    title: '2023 Fiberglass New Products',
    ref : 'prmedia_thermatru_press_release_shaker',
    navigationLevel : -1,
    path : baseUrl+'datas/prmedia/23_Therma-Tru_PressRelease_FG New Products.pdf',
    type : 'pdf',
    parent : 'prmedia_thermatru_press_release',
}


